import { render, staticRenderFns } from "./Brotje.vue?vue&type=template&id=1b5b2762&"
import script from "./Brotje.vue?vue&type=script&lang=js&"
export * from "./Brotje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports